module.exports = __webpack_public_path__ + "img/确认.87aea7f0.svg";